"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartReportIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ChartReportIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M5.91914503,19.3939193 C5.70158941,19.9015491 5.11371048,20.1367007 4.6060807,19.919145 C4.09845092,19.7015894 3.86329935,19.1137105 4.08085497,18.6060807 L7.41632982,10.823306 L11.3441535,11.805262 L12.2792408,9 L16.381966,9 L18.1055728,5.5527864 C18.3525621,5.05880791 18.9532351,4.85858356 19.4472136,5.10557281 C19.9411921,5.35256206 20.1414164,5.9532351 19.8944272,6.4472136 L17.618034,11 L13.7207592,11 L12.6558465,14.194738 L8.58367018,13.176694 L5.91914503,19.3939193 Z" }))); };
exports.ChartReportIcon = ChartReportIcon;
